export enum VACANCIES_REFERENCE_SECTION {
  VACANCIES = 'Vacancies',
  GENERAL = 'GENERAL',
}
export enum VACANCIES_REFERENCE_CATEGORIES {
  CATEGORIES = 'Categories',
  TYPES = 'Types',
  MODALITY = 'Modalities',
  LOCATION = 'Locations',
  ANSWERS = 'Answers',
  POSITIONS = 'POSITIONS',
}

export const VACANCIES_ACTIONS = {
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  RESTORE: 'RESTORE',
  PAUSE: 'PAUSE',
  CONTINUE: 'CONTINUE',
  VIEW_SUBMISSION: 'VIEW_SUBMISSION',
  VIEW: 'VIEW',
  REPOST: 'REPOST',
};

export enum VACANCIES_REFERENCE_ANSWERS_FIELD {
  ANSWER = 'Answer',
}

export enum VACANCIES_REFERENCE_CATEGORY_FIELD {
  NAME = 'Name',
  POSITION = 'POSITION',
  CATEGORY = 'CATEGORY',
}

export enum VACANCIES_REFERENCE_TYPES_FIELD {
  NAME = 'Name',
}

export enum VACANCIES_REFERENCE_MODALITY_FIELD {
  NAME = 'Name',
}

export enum VACANCIES_REFERENCE_LOCATION_FIELD {
  NAME = 'Name',
}
export enum VACANCIES_STATUS {
  ACTIVATED = 'ACTIVATED',
  INACTIVE = 'INACTIVE',
  DRAFT = 'DRAFT',
  SCHEDULED = 'SCHEDULED',
  DELETED = 'DELETED',
  PAUSED = 'PAUSED',
  EXPIRED = 'EXPIRED',
}
